import {FETCH_INTERNSHIP_REQUEST, FETCH_INTERNSHIP_SUCCES, FETCH_INTERNSHIP_ERROR} from '../constants/Internship'
import { jsonGet, errorHandler } from '../utils/Request';

const loadInternship = id => (dispatch) => {
  const apiUrl = '/internship/' + id;
  dispatch({
    type: FETCH_INTERNSHIP_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_INTERNSHIP_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_INTERNSHIP_ERROR
      });
      errorHandler(e);
    });
};

export { loadInternship };



// WEBPACK FOOTER //
// ./src/actions/InternshipActions.js